import * as Sentry from '@sentry/react';
import { registerSW } from 'virtual:pwa-register';

export function registerPwa(rootElement: HTMLElement) {
  const origUrl = location.href;
  const updateSW = registerSW({
    immediate: false,
    // this can be removed when reload is fixed in flutter
    async onNeedRefresh() {
      const diagnostics = {
        rootChildCountAtUpdate: rootElement.childElementCount,
        visibilityState: document.visibilityState,
        serviceWorkerControllerState: navigator.serviceWorker.controller?.state ?? 'none',
        isFlutterWebView: Boolean(window.flutter_inappwebview),
      };
      Sentry.setTag('pwa_update_pending', 'true');
      Sentry.setContext('pwa_update', diagnostics);
      Sentry.addBreadcrumb({
        category: 'pwa.service-worker',
        message: 'Service-worker refresh started; application remains mounted until reload',
        level: 'info',
        data: diagnostics,
      });

      history.replaceState({}, '', origUrl);

      try {
        await updateSW();
      } catch (error) {
        Sentry.captureException(error, {
          tags: {
            operation: 'pwa-service-worker-update',
          },
          contexts: {
            pwa_update: diagnostics,
          },
        });

        Sentry.setTag('pwa_update_pending', 'false');
        throw error;
      }
    },
  });
}
